'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';

var ResultInfo = /*#__PURE__*/function (_Component) {
  _inherits(ResultInfo, _Component);

  function ResultInfo() {
    _classCallCheck(this, ResultInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResultInfo).apply(this, arguments));
  }

  _createClass(ResultInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          gradeType = _this$props.gradeType,
          localizedTextKey = _this$props.localizedTextKey;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: "result-text-small",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: localizedTextKey + ".result.title." + gradeType
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "result-description",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: localizedTextKey + ".result.description"
          })
        })]
      });
    }
  }]);

  return ResultInfo;
}(Component);

ResultInfo.propTypes = {
  localizedTextKey: PropTypes.string,
  gradeType: PropTypes.string
};
export { ResultInfo as default };